module.exports = __webpack_public_path__ + "static/media/13-Hamburg.f02ec354.jpg";